import { Core } from "@faire/design-tokens";
import styled from "styled-components";
// eslint-disable-next-line @faire/no-text-transform
export var EyebrowText = styled.label.withConfig({
    componentId: "sc-5914a0cf-0"
})([
    "letter-spacing:2px;text-transform:uppercase;color:",
    ";"
], function(props) {
    var _props_$color;
    return (_props_$color = props.$color) !== null && _props_$color !== void 0 ? _props_$color : Core.text.subdued;
});
